import React, { useState, useRef, useEffect, useContext } from "react";
import { Grid, Image, Button } from 'semantic-ui-react'
import { NavLink, useLocation } from "react-router-dom";
import "./Header.scss";
import logo_img from "../../assets/home/atar_logo.png";
import nav_img from "../../assets/home/no-img.png";
import close from "../../assets/home/close.svg";
import headermenu from "../../assets/home/headermenu.png";
import { useSelector, useDispatch } from 'react-redux'
import onClickOutside from "react-onclickoutside";
import { logout } from '../../store/AuthRedux'
import { useTranslation } from "react-i18next";

function NavMob() {
  const location = useLocation();

  const dispatch = useDispatch()
  const { t, i18n } = useTranslation();
  const token = useSelector((state) => state.auth.token)
  const userDetails = useSelector((state) => state.user.userDetails)
  const notifications = useSelector((state) => state.user.notifications)
  const [active, setActive] = useState('')
 const[not, setNot] = useState(false)


 const notHandle = ()=>{
  setNot(true)
 }





  const changeLang = (val) => {
    i18n.changeLanguage(val)
    setActive('')
    // window.location.reload(false);
  }

  useEffect(() => {
    setActive(false);
  }, [location.pathname]);


  NavMob.handleClickOutside = () => {
    setActive(false);
  };
  useEffect(() => {
    window.scrollTo(0, 0)
  }, []);

  return (
    <div className="sticky">
      <Grid className="navbar">
        <Grid.Row className="nav_sec">
          <Grid.Column mobile={8} tablet={10} computer={8}>
            <NavLink to=""><img className="logo" src={logo_img} alt="Logo" /></NavLink>
          </Grid.Column>


          <Grid.Column className="right_sec" mobile={8} tablet={6} computer={8}>
            {token ? null : <NavLink className="nav-link-button loginButtons" aria-current="page" to="/login">Login</NavLink>}


            <div className="headerMenu mobiles" onClick={() => setActive('pannel1')}>
              <Image src={headermenu} />
            </div>

            <div className="mobilenav mobilenavForMob" style={{ display: ((active === 'pannel1') ? 'block' : 'none') }}>
              <ul className="nav">
                <li className="nav-item mx-3 mobiles">
                  <img className="logo2" src={logo_img} />
                  <div className="cross_icon" onClick={() => setActive(' ')}> <img src={close} /></div>
                </li>

                <div className="blue_border clearall"></div>

                <li className="nav-item mx-3">
                  <NavLink activeClassName="" className="nav-link" aria-current="page" to="">
                    Home
                  </NavLink>
                </li>

                <li className="nav-item mx-3">
                  <NavLink activeClassName="active" className="nav-link" aria-current="page" to="/contest">
                    Contests
                  </NavLink>
                </li>
                <li className="nav-item mx-3">
                  <NavLink activeClassName="active" className="nav-link" to='/aboutus'>
                    About us
                  </NavLink></li>

                <li className="nav-item mx-3">
                  <NavLink activeClassName="active" className="nav-link" aria-current="page" to="/contactus">
                    Contact
                  </NavLink>
                </li>
                {token && (<>
                  <div className="blue_border mx-3"></div>
                  <li className="nav-item mx-3 mobiles">
                    <NavLink className="name-link" aria-current="page" to="" activeClassName="active"   >
                      <div>
                        <Image verticalAlign='middle' style={{ height: 30, maxWidth: 30 }} src={userDetails?.profile?.profileURL ? userDetails?.profile?.profileURL : nav_img} size='tiny' circular />
                        {' '}
                        <span>{userDetails?.profile?.name}</span>
                        </div>
                    </NavLink>
                  </li>
                  <div className="blue_border mobiles"></div>
                </>)}
                <li className="nav-item mx-3">
                  <NavLink className="nav-link" aria-current="page" to="/profile">
                    Profile Settings
                  </NavLink>
                </li>

                <li className="nav-item">
                  <NavLink className="nav-link" aria-current="page" to="/participationhistory">
                    Participation History
                  </NavLink>
                </li>

                <li className="nav-item ">
                  <NavLink className="nav-link" aria-current="page" to="/rewards">
                    My rewards
                  </NavLink>
                </li>

                <li className="nav-item">
                  <NavLink className="nav-link" aria-current="page" to="/referearn">
                    Refer & Earn
                  </NavLink>
                </li>

                {token && (<li className="nav-item notification">

                  {
                   
                   (notifications && notifications.data)?
                   
                    
                  <span className="count">
                   
                    {(notifications && notifications.data) ? notifications?.count : 0}
                    
                    </span>:null
                    
                  
                  }
                  <NavLink className="nav-link" aria-current="page" to="/notifications" onClick={()=> notHandle}>
                    Notifications
                  </NavLink>
                </li>)}

                <li className="nav-item">
                  <div onClick={() => setActive('pannel2')} className="nav-link"><span className="language_left">language</span><span className="language_right"><i className="fa fa-long-arrow-right" aria-hidden="true"></i></span>
                  </div>
                </li>

                <div className="blue_border"></div>

                {token && (<li className="nav-item mx-3">
                  <NavLink onClick={() => { dispatch(logout()); setActive('') }} className="nav-link" aria-current="page" to="/login">
                    Log out
                  </NavLink>
                </li>)}

              </ul>
            </div>

            <div className="mobilenav mobilenavForMob" style={{ display: ((active === 'pannel2') ? 'block' : 'none') }}>
              <ul className="nav">
                <li className="nav-item mx-3 mobiles">
                  <img className="logo2" src={logo_img} />
                  <div className="cross_icon" onClick={() => setActive('pannel1')}><img src={close} /></div>
                </li>
                <div className="blue_border clearall"></div>
                <li className="nav-item mx-3">
                  Choose your language
                </li>

                <li className="nav-item mx-3">
                  <div className="language_button"><Button className={i18n.language == 'en' ? "active" : ''} onClick={() => changeLang('en')}>English</Button></div>
                </li>
                <li className="nav-item mx-3">

                  <div className="language_button"><Button className={i18n.language == 'hi' ? "active" : ''} onClick={() => changeLang('hi')}>Hindi ( हिंदी )</Button></div>
                </li>
                <div className="blue_border clearall"></div>
                <li className="nav-item mx-3">
                  <div className="backMenu" onClick={() => setActive('pannel1')}> Back to menu</div>
                </li>
              </ul>
            </div>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </div>
  );
};

const clickOutsideConfig = {
  handleClickOutside: () => NavMob.handleClickOutside,
};
export default onClickOutside(NavMob, clickOutsideConfig);